import i18n from '@/plugins/i18n'

export enum SortTypes {
  NameDescending = 'a-to-z',
  NameAscending = 'z-to-a',
  DateDescending = 'newer',
  DateAscending = 'oldest',
  ManufacturerAscending = 'manufacturer-asc',
  ManufacturerDescending = 'manufacturer-desc',
}

export type SortType =
  | ''
  | SortTypes.DateDescending
  | SortTypes.DateAscending
  | SortTypes.NameDescending
  | SortTypes.NameAscending
  | SortTypes.ManufacturerAscending
  | SortTypes.ManufacturerDescending

export const sortOptions = [
  // eslint-disable-next-line
  // @ts-ignore
  { name: i18n.global.t('None'), value: '' },
  { name: i18n.global.t('Newer'), value: SortTypes.DateDescending },
  { name: i18n.global.t('Oldest'), value: SortTypes.DateAscending },
]

export const approvalSortOptions = [
  ...sortOptions,
  { name: i18n.global.t('Name: Ascending'), value: SortTypes.NameAscending },
  { name: i18n.global.t('Name: Descending'), value: SortTypes.NameDescending },
  { name: i18n.global.t('Manufacturer: Ascending'), value: SortTypes.ManufacturerAscending },
  { name: i18n.global.t('Manufacturer: Descending'), value: SortTypes.ManufacturerDescending },
]
